import { useEffect, useState } from "react";

const PHONE = "919566413125"; // no + or spaces for wa.me
const MESSAGE =
  "Hi Varnella, I'd like to discuss a custom surface project for my space.";

export default function WhatsAppFab() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 1400);
    return () => clearTimeout(t);
  }, []);

  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat with Varnella on WhatsApp"
      className={`fixed z-40 flex items-center gap-3 group transition-all duration-700 ${
        mounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
      }`}
      style={{ bottom: "84px", right: "20px" }}
    >
      {/* Tooltip / label */}
      <span
        className="hidden md:inline-block glass rounded-full px-4 py-2 text-[11px] tracking-[0.22em] uppercase text-stone-800 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-500"
      >
        Chat with a designer
      </span>

      {/* Pulsing ring */}
      <span className="relative flex items-center justify-center">
        <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-40 animate-ping" />
        <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] shadow-[0_12px_30px_rgba(37,211,102,0.35)] transition-transform duration-500 group-hover:scale-105">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            className="w-7 h-7 text-white"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.407-.545-.489-1.146-1.253-1.46-1.907a.63.63 0 0 1-.076-.302c0-.396 1.394-1.055 1.394-1.394 0-.086-.031-.161-.075-.245-.24-.5-.564-1.052-.808-1.556-.104-.211-.276-.503-.487-.503H12.6c-.319 0-.588.115-.798.315C11.166 11.66 11 12.284 11 12.928c0 .69.229 1.34.516 1.964.706 1.516 1.729 2.892 3.086 3.978 1.098.887 2.443 1.62 3.856 1.848.311.05.616.056.916.056.634 0 1.276-.148 1.769-.463.398-.253.719-.634.883-1.06.06-.156.09-.322.09-.487 0-.263-.09-.517-.293-.66-.212-.16-.616-.311-1-.464-.235-.09-.516-.181-.727-.181-.02 0-.02 0-.086.043zM16 5.333c-5.891 0-10.667 4.776-10.667 10.667 0 2.176.652 4.294 1.869 6.096l-1.203 4.401 4.516-1.183c1.729 1.107 3.75 1.687 5.816 1.687 5.891 0 10.667-4.776 10.667-10.667 0-2.848-1.11-5.526-3.124-7.541C21.526 6.443 18.848 5.333 16 5.333z" />
          </svg>
        </span>
      </span>
    </a>
  );
}
